import { sdkRequest } from '@eventbrite/http';
import { Organization } from '../types';

export const getOrganizations = async ({
    publicId,
}: {
    publicId: string;
}): Promise<{ organizations: Organization[] }> => {
    return sdkRequest(`/api/v3/users/${publicId}/organizations/`);
};
